<template>
    <div class="page">
        <div class="term">
            对应学期：
            <a-select v-model="termId" style="width: 322px">
                <template>
                    <a-select-option :value="item.id" v-for="item in termList" :key="item.id">
                        {{ item.termName }}
                    </a-select-option>
                </template>
            </a-select>
            <a-button type="primary" style="margin-left: 24px;" @click="getQuesFormList">查询</a-button>
        </div>
        <div class="table">
            <a-table :columns="columns" :dataSource="quesFormList" class="c-table" :pagination="pagination"
                :rowKey="getRowKey" @change="tableChange">
                <!-- 问卷名 -->
                <template slot="qtitle" slot-scope="text, record">
                    <a-popover>
                        <template slot="content">
                            <p>{{ record.title }}</p>
                        </template>
                        <div class="ellipsis">{{ record.title }}</div>
                    </a-popover>
                </template>
                <!-- 开始时间 -->
                <template slot="startTime" slot-scope="text, record">
                    <a-popover>
                        <template slot="content">
                            <p>开始时间为{{ record.startTime }} 00:00:00</p>
                        </template>
                        <div class="ellipsis">{{ record.startTime }}</div>
                    </a-popover>
                </template>
                <!-- 结束时间 -->
                <template slot="endTime" slot-scope="text, record">
                    <a-popover>
                        <template slot="content">
                            <p>结束时间为{{ record.endTime }} 23:59:59</p>
                        </template>
                        <div class="ellipsis">{{ record.endTime }}</div>
                    </a-popover>
                </template>
                <!-- 发布状态 -->
                <template slot="status" slot-scope="text, record">
                    <span class="published">
                        {{ record.state == 0 ? '' : '已发布' }}
                    </span>
                </template>
                <!-- 是否停用 -->
                <template slot="deactivate" slot-scope="text, record">
                    <span :class="record.state == 1 && record.enabled == 0 ? 'stop' : ''">
                        {{ record.state == 1 && record.enabled == 0 ? '已停用' : '' }}
                    </span>
                </template>
                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <div class="operate-box">
                        <a @click="openDrawer(record.id)" class="operate"> 查看 </a>
                    </div>
                </template>
            </a-table>
        </div>
        <!-- 查看详情 -->
        <QuestionnaireDetail v-if="showDrawer" :showDrawer.sync="showDrawer" :formId="formId">
        </QuestionnaireDetail>
    </div>
</template>
<script>
import Vue from 'vue';
import moment from 'moment';
import questionnaire from '../../api/questionnaire'
import QuestionnaireDetail from './components/QuestionnaireDetail.vue'
const columns = [
    {
        title: '对应学期',
        dataIndex: 'termName',
        key: 'termName',
    },
    {
        title: '问卷标题',
        dataIndex: 'title',
        scopedSlots: { customRender: 'qtitle' },
        key: 'title',
    },
    {
        title: '开始时间',
        dataIndex: 'startTime',
        scopedSlots: { customRender: 'startTime' },
        key: 'startTime',
    },
    {
        title: '结束时间',
        dataIndex: 'endTime',
        scopedSlots: { customRender: 'endTime' },
        key: 'endTime',
    },
    {
        title: '发布状态',
        dataIndex: 'status',
        key: 'status',
        scopedSlots: { customRender: 'status' },
    },
    {
        title: '是否停用',
        dataIndex: 'deactivate',
        scopedSlots: { customRender: 'deactivate' },
        key: 'deactivate',
    },
    {
        title: '操作',
        dataIndex: 'action',
        scopedSlots: { customRender: 'action' },
    },
]
export default {
    name: "questionnaireSurvey",
    data() {
        return {
            schoolId: Vue.ls.get('schoolId'),
            termId: '',
            termList: [],
            columns,
            formId: 0,
            quesFormList: [],
            loading: true,
            showDrawer: false,
            pagination: {
                pageSize: 10,
                total: 0,
                showTotal: total => `总共 ${total} 条`, // 显示总数
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
                current: 1,
                currentPage: 1,
            }, //分页数据对象
        }
    },
    components: {
        QuestionnaireDetail,
    },
    created() {
        this.getTermList()
        this.getQuesFormList()
    },
    methods: {
        // 获取学期列表
        async getTermList() {
            const data = await questionnaire.getTermList({ schoolId: this.schoolId })
            if (!data) return
            // console.log(data, '获取学期列表')
            this.termList = data.data
            this.termList.unshift({ id: '', termName: "全部" })
        },
        // 获取问卷列表
        async getQuesFormList() {
            let params = {
                termId: this.termId,
                currentPage: this.pagination.currentPage,
                pageSize: this.pagination.pageSize,
                bureauId: Vue.ls.get('bureauId')
            }
            this.loading = true
            const { data } = await questionnaire.getQuestionnaireList(params)
            if (!data) return
            // console.log(data.list, '列表')
            data.list.forEach(item => {
                item.startTime = moment(item.startTime).format('YYYY-MM-DD')
                item.endTime = moment(item.endTime).format('YYYY-MM-DD')
            });
            this.quesFormList = data.list
            this.loading = false
            this.pagination.total = data.pagination.total
        },
        openDrawer(id) {
            // console.log(id)
            this.showDrawer = true
            this.formId = id
        },
        tableChange(pagination) {
            // console.log(pagination)
            this.pagination.current = pagination.current
            this.pagination.currentPage = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.getQuesFormList()
        },
        getRowKey(record, index) {
            return index;
        },
    },
}
</script>

<style scoped lang="less">
.page {
    padding: 20px;
}

.term {
    background-color: #fff;
    padding: 24px;
    margin-bottom: 16px;
}

.table {
    background-color: #fff;
    padding: 24px;
}

.ant-table-thead>tr>th {
    padding: 12px 16px;
}

.published {
    color: #00D039; // #00D039  #1890ff
}

.stop {
    color: #FF0000;
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
}

.operate-box {
    display: flex;
    justify-content: space-between;

    a {
        color: #1890ff;
    }
}
</style>